import styled from 'styled-components';

const Wrapper = styled.section`

    padding-top: var(--spacing-xx-large);
	.loadingstyle {
		height: calc(100vh - var(--px-250)) !important;
	}

	//pagination

	.pagerholder {		
		width: calc(100vw - var(--px-80)) !important;
		margin: 0 auto;
		max-width: 2048px;
		display: flex;
		padding: var(--px-24) 0;
	}

	.permissiongroup-paging {
		justify-content: flex-end;
		line-height: normal;
		min-width: auto !important;
		font-size: var(--px-14);
	}


	.mainwrapper{
		overflow: hidden;
        background: var(--neutrals-bg-gradient1);
	
	.message{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: calc(100vh - var(--px-194));

		&h5{
			color: var(--neutrals-900);
		}
	}

	//heading
	.permissiongroup {
		.pageheading {
			display: flex;
			padding: var(--px-20) 0;
			svg {
				min-width: var(--px-25) !important;
				min-height: var(--px-25) !important;
				margin-right: var(--px-10);
			}

			h3 {
				margin: 0;
				line-height: var(--px-25);
			}
		}
	}

	//addon

	.add-on {
		display: flex;
		margin-right: auto;
		padding: 0 0 var(--px-20) 0;

		.adduser {
			.motif-button {
				height: var(--px-40);
				width: var(--px-100);
			}
		}

		.search {
			width: 16%;
			margin-right: auto;
		}
	}

    .norecord{
        height: calc(100vh - var(--px-316));
        display: inline-block;
        width: 100%;
        display: flex;
        justify-content: center;
        flex: 0 auto;
        align-items: center;
        font-size: var(--px-16);
        color: var(--neutrals-700);
    }

    .managepermissionTable {
        /* height: 100%; */
        overflow-y: auto;
        user-select: none;
        .motif-table {
            height: calc(100vh - var(--px-265)) !important;
    
            &.ag-theme-material .ag-checkbox-input-wrapper:focus-within {
                box-shadow: none;
            }
    
            .ag-header-cell {
                color: var(--neutrals-700);
                &:hover,
                    &.ag-header-cell-moving{
                        background: transparent!important;
                    }
            }
    
            .ag-header-cell .ag-header-select-all{
                visibility: hidden;
            }
    
            .ag-body-viewport{
    
                &:after{
                    content: none;
                }
            }
    
            .ag-root.ag-layout-normal {
                overflow-y: auto;
                width: 100%;
            }
    
            .ag-root.ag-layout-auto-height {
                display: block;
            }
    
            .ag-center-cols-viewport {
                overflow-x: hidden;
            }
    
            .ag-row{
                border-bottom: none;
    
                .ag-cell-value{
                    /* font-weight: 100; */

					a.groupname{
						width: 100%;
						display: inline-block;
						color: var(--blue-600);

						.ellipses{
							color: var(--blue-600)!important;
						}
					}
                }
            }
    
            .ag-row,
            .ag-row-hover {
				.ag-cell-wrapper{
					width: 100%;
					display: grid;
				}
				
            }
    
            .ag-cell,
            .ag-header-cell {
                display: flex;
  
    
                .ag-header-cell-text{
                    font-size: var(--px-14) !important;
				font-weight: 400 !important;
				line-height: var(--px-20) !important;
				color: var(--neutrals-900);
                    
                }
            }            
    
            .roleType.disabled,
            .roleType.disabled *{
                color: var(--neutrals-300)!important;
                fill: var(--neutrals-300);
            }
            .noptr{
                pointer-events: none;
            }
            .disabled{
                color: var(--neutrals-300)!important;
                fill: var(--neutrals-300);
            }
            .groupName-cell {
                color: var(--blue-600) !important;                
                cursor: pointer;
                a {
                    text-decoration: none;
                    font-weight: 300;
                }
            }
    
            .roleType {    
                color: var(--ui-text-main);
                &.enable.icon{
                    fill: var(--neutrals-1000)!important;
                }                
                .columnName {
                    text-decoration: none;
                }
                }

                .ellipses {
                    display: flex;
                }
            }
    
            .errorRow {
                color: var(--red-600) !important;
            }
        }
    
        .ag-body-horizontal-scroll {
			overflow: auto;
        }
    
        .ag-layout-normal {
            &::-webkit-scrollbar {
                width: var(--px-6);
            }
            &::-webkit-scrollbar-track {
                background: var(--neutrals-200);
                width: var(--px-6);
            }
            &::-webkit-scrollbar-thumb {
                background: var(--neutrals-300);
                width: var(--px-6);
                cursor: pointer;
            }
            &::-webkit-scrollbar-thumb:hover {
                background: var(--neutrals-700);
            }
        }
    
    }

`;

export default Wrapper;
